var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.805 38.805 50 25 50C11.195 50 0 38.805 0 25C0 11.195 11.195 0 25 0C38.805 0 50 11.195 50 25Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0V25L35 30L23.9463 50C24.3425 50 24.6038 50 25 50C38.8163 50 50.0001 38.8162 50.0001 25C50.0001 11.1837 38.8163 0 25 0Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.805 38.805 50 25 50C11.195 50 0 38.805 0 25C0 11.195 11.195 0 25 0C38.805 0 50 11.195 50 25Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0V25L35 30L23.9463 50C24.3425 50 24.6038 50 25 50C38.8163 50 50.0001 38.8162 50.0001 25C50.0001 11.1837 38.8163 0 25 0Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3003 13.75H25.0003V30L21.2503 28.75L3.95029 11.575H3.92529C8.35029 4.61251 16.1378 0 25.0003 0C34.7503 0 43.1878 5.60001 47.3003 13.75Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94727 11.5801L15.001 30.1576L21.2498 28.7501L3.94727 11.5801Z",
    fill: "#DD2C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9453 50L35.1128 29.9262L29.9991 26.25L23.9453 50Z",
    fill: "#558B2F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3304 13.7501H24.9991L23.0254 19.4751L47.3304 13.7501Z",
    fill: "#F9A825"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 25.0001C36.25 31.2113 31.2113 36.2501 25 36.2501C18.7888 36.2501 13.75 31.2113 13.75 25.0001C13.75 18.7889 18.7888 13.7501 25 13.7501C31.2113 13.7501 36.25 18.7889 36.25 25.0001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 25C33.75 29.8337 29.8337 33.7499 25 33.7499C20.1662 33.7499 16.25 29.8337 16.25 25C16.25 20.1662 20.1662 16.25 25 16.25C29.8337 16.25 33.75 20.1662 33.75 25Z",
    fill: "#2196F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeLogo);
export default __webpack_public_path__ + "static/media/Chrome_Logo.86ee259c5806987c7d75db66b94b0a21.svg";
export { ForwardRef as ReactComponent };